import TextWidget from './TextWidget';
import SelectWidget from './SelectWidget';
import DateWidget from './DateWidget';
import EmailWidget from './EmailWidget';
import RadioWidget from './RadioWidget';
import CheckboxWidget from './CheckboxWidget';
import YesNoWidget from './YesNoWidget';

const widgets = {
  TextWidget,
  SelectWidget,
  DateWidget,
  EmailWidget,
  RadioWidget,
  CheckboxWidget,
  yesNo: YesNoWidget,
};

export default widgets;
